import RegistrationWithLink from './RegistrationWithLink'
import RegistrationWithPeriod from './RegistrationWithPeriod'

export default [
    {
        path: '/daftar/:slug',
        name: 'registration.normal',
        component: RegistrationWithPeriod,
    }, {
        path: '/daftarspesial/:slug',
        name: 'registration.special',
        redirect: { name: 'registration.link' }
    }, {
        path: '/d/:slug',
        component: RegistrationWithLink,
        name: 'registration.link',
    }
]
